import { render } from "./DashboardBasicProfile.vue?vue&type=template&id=ebd1d5a2"
import script from "./DashboardBasicProfile.vue?vue&type=script&lang=js"
export * from "./DashboardBasicProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__